// Aquí está el slice de registro de usuarios
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sendRegister: false,
  failureRegister: false,
  loading: false,
  error: null,
};

const registerSlice = createSlice({
  name: "register",
  initialState,
  reducers: {
    registerPending: (state) => {
      state.loading = true;
      state.sendRegister = false;
      state.failureRegister = false;
      state.error = null;
    },
    registerSuccess: (state) => {
      state.loading = false;
      state.sendRegister = true;
      state.failureRegister = false;
    },
    registerFailure: (state, action) => {
      state.loading = false;
      state.sendRegister = true;
      state.failureRegister = true;
      state.error = action.payload; // mensaje de error
    },
    registerReset: (state) => {
      state.loading = false;
      state.sendRegister = false;
      state.failureRegister = false;
      state.error = null;
    },
  },
});

export const {
  registerPending,
  registerSuccess,
  registerFailure,
  registerReset,
} = registerSlice.actions;
export default registerSlice.reducer;
